<template>
  <div class="device-manage" :class="{ 'app-region blank-t-v blank-l-h blank-r-h': !communityId }">
    <a-row type="flex" align="bottom" :gutter="[16, 16]" class="mg-normal">
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>设备名称</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入设备名称" v-model="table.search.device_name"></a-input>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="24" :xl="8">
        <a-row :gutter="[8, 8]">
          <a-col>
            <p>设备码</p>
          </a-col>
          <a-col>
            <a-input placeholder="请输入设备唯一编码" v-model="table.search.name"></a-input>
          </a-col>
        </a-row>
      </a-col>

      <a-col :span="24" :xl="8">

      </a-col>
      <a-col :span="24" :xl="8">
        <a-space>
          <a-button type="primary" @click="addDevice">新增设备</a-button>
          <!-- <a-button type="primary"
                    @click="editDevice">编辑设备</a-button> -->
          <a-button type="primary" @click="searchTable">查询</a-button>
          <a-button @click="resetSearchTable">重置</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-table class="mg-normal" :loading="table.loading" :columns="table.columns" :data-source="table.data" rowKey="id"
      :pagination="table.page" @change="handlePageChange">
      <template slot="action" slot-scope="text, data">
        <a-space>
          <template v-if="data.status">
            <a-button type="link" @click="editDevice(data)">编辑</a-button>
            <a-button type="link" @click="openDoor(data)" v-if="!data.showLoading">远程开门</a-button>
            <a-icon type="loading" v-else></a-icon>
          </template>
          <a-button type="link" @click="editDevice(data)">编辑</a-button>
          <a-button type="link" @click="syncFace(data)" v-if="dnkFaceSwitch === 1">同步人脸</a-button>
          <a-button type="link" @click="delDevice(data)" style="color:#fb8387">删除</a-button>
          <a-button type="link" @click="delFace(data)" style="color:#fb8387" v-if="dnkFaceSwitch === 1">清空人脸</a-button>
        </a-space>
      </template>
    </a-table>
    <a-modal :title="modal.title" :confirm-loading="modal.loading" v-model="modal.show" @ok="confirmModal"
      destroy-on-close centered>
      <a-form-model ref="modalForm" :model="form" layout="vertical" :rules="modal.rules">
        <a-form-model-item label="设备名称" prop="device_name">
          <a-input v-model="form.device_name" placeholder="请输入设备名称" allow-clear></a-input>
        </a-form-model-item>
        <a-form-model-item label="设备唯一编号" prop="name">
          <a-input v-model="form.name" placeholder="请输入设备唯一编号" allow-clear></a-input>
        </a-form-model-item>
        <a-form-model-item label="设备内网楼栋号">
          <a-input v-model="form.build" placeholder="请输入设备内网楼栋号" allow-clear></a-input>
        </a-form-model-item>
        <a-form-model-item label="设备内网单元号">
          <a-input v-model="form.unit" placeholder="请输入设备内网单元号" allow-clear></a-input>
        </a-form-model-item>

        <a-form-model-item label="应用社区" v-if="communityOptionsO[form.community_id] || communityOptionsO[communityId]">
          {{ form.community_id > 0 ? communityOptionsO[form.community_id] : communityOptionsO[communityId] }}
          <!-- <a-select v-model="form.community_id"
                    placeholder="请选择应用社区"
                    :disabled="modal.isEdit">
            <a-select-option :value="value.id"
                             v-for="value in communityOptions"
                             :key="value.id">{{value.name}}</a-select-option>
          </a-select> -->
        </a-form-model-item>
        <a-form-model-item label="绑定单元" >
          <div>
            <a-button type="primary" @click="showModal">选择</a-button>
          </div>
          <div class="mg-normal" >
            <a-tag class="large" v-for="(value, index) in form.house" :key="index" v-if="value.full_name">{{ value.full_name }}</a-tag>
          </div>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal :title="modal2.title" v-model="modal2.show" @ok="confirmModal2" destroy-on-close width="60%" centered>
      <tree-select v-model="modal2.house" :data="tree.data" :params="tree.params" :load-data="$houseTreeData"
        @load="loadTreeSelectNode"></tree-select>
    </a-modal>
  </div>
</template>

<script>
import {
  deviceTypeText
} from '@/io/dict.js';
import CommunityService from '@/io/community.js';

import DeviceService from '@/io/device.js';
import { mapState } from 'vuex'

export default {
  name: 'DeviceManage',
  props: {
    communityId: {
      type: Number,
      default: null
    },
    dnkFaceSwitch:{
      type: Number,
      default: 0
    }
  },
  data() {
    let self = this;
    return {
      communityOptions: [],
      communityOptionsO: {},
      deviceTypeText,
      table: {
        loading: false,
        search: {
          number: null,
          model: null,
          type: []
        },
        page: {
          total: 0,
          current: 1,
          pageSize: 10,
          showQuickJumper: true,
          showSizeChanger: true,
          showTotal() {
            return `共${self.table.page.total}条`;
          }
        },
        data: [],
        columns: [
          {
            title: '设备名称',
            dataIndex: 'device_name'
          },
          {
            title: '设备码',
            dataIndex: 'name'
          },
          {
            title: '楼栋',
            dataIndex: 'build'
          },
          {
            title: '单元',
            dataIndex: 'unit'
          },
          // {
          //   title: '设备型号',
          //   dataIndex: 'model'
          // },
          // {
          //   title: '设备类型',
          //   dataIndex: 'typeText'
          // },
          {
            title: '设备状态',
            customRender: text => text.is_online ? "在线" : ''
          },
          {
            title: '操作',
            scopedSlots: { customRender: 'action' },
          }
        ]
      },
      tree: {
        data: [],
        params: {
          children: "children",
          title: "name",
          key: "_id",
        },
      },
      form: {
        name: null,
        community: [],
        community_id: [],
        house: []
      },
      modal2: {
        title: '选择楼栋单元',
        show: false,
        house: [],
      },
      modal: {
        id: null,
        name: null,
        title: '编辑设备',
        show: false,
        loading: false,

        rules: {
          device_name: [
            {
              required: true,
              message: '请填写设备名称'
            }
          ],
          name: [
            {
              required: true,
              message: '请填写设备唯一编号'
            }
          ],
          // community_id: [
          //   {
          //     required: true,
          //     message: '请选择社区'
          //   }
          // ],
          build: [
            {
              required: true,
              message: '请填写设备内网楼栋号'
            }
          ],
          unit: [
            {
              required: true,
              message: '请填写设备内网单元号'
            }
          ],
          house: [
            {
              required: true,
              message: '请绑定单元'
            }
          ],
        }
      },
    }
  },
  computed: {
    ...mapState(['community'])
  },
  watch: {
    communityId: {
      handler(newValue, oldValue) {
        if (newValue || this.community?.id) {
          this.initTreeData()
          this.searchTable();
        }
      },
      immediate: true
    }
  },
  activated() {
    this.initCommunity().then((f) => {
      if (this.communityId || this.community?.id) {
        this.initData();
        this.initTreeData()
      }
    });

  },
  methods: {
    syncFace(data) {
      this.$confirm({
        title: '提示',
        content: '确认同步人脸？',
        onOk: () => {
          this.table.loading = true
          DeviceService.syncFace([data.id])
            .then(res => {
              this.$afterFormSubmit('同步成功', () => {
                this.initTreeData();
              });
            })
            .finally(_ => this.table.loading = false)
        }
      });
    },
    delFace(data) {
      this.$confirm({
        title: '提示',
        content: '确认清空人脸？',
        onOk: () => {
          DeviceService.clearFace([data.id]).then(res => {
            this.$afterFormSubmit('删除成功', () => {
              this.initTreeData();
            });
          });
        }
      });
    },
    delHouse(index) {
      this.form.house.splice(index, 1);
    },
    loadTreeSelectNode(data) {
      data.children.forEach((val) => {
        this.$set(val, "disabled", val.level <= 1);
      });
    },
    initTreeData() {
      return this.$houseTreeData([], [1, 2], this.communityId || this.community.id).then((res) => {
        this.tree.data = res.map((val) => {
          val.disabled = true;
          return val;
        });
      });
    },
    showModal() {
      this.modal2.show = true;
      // console.log(this.form.house);
      setTimeout(() => {
        this.modal2.house = this.form && this.form.house && this.form.house.length ? this.$createNewVariable(this.form.house) : [];

      }, 200);
    },
    initCommunity() {
      return CommunityService.listPage().then(res => {
        this.communityOptions = res;
        // this.communityOptionsO = this.communityOptions.map(r => {
        //   return { [r.id]: r.name }
        // })
        this.communityOptions.forEach(r => {
          this.communityOptionsO[r.id] = r.name
        });


      }).catch(err => { });
    },
    openDoor(data) {
      data.showLoading = true;
      DeviceService.openDoor(this.communityId, data.id).then(res => {
        this.$message.success('远程开门成功');
      }).catch(err => { }).finally(() => {
        data.showLoading = false;
      });
    },
    addDevice() {
      this.modal.title = '添加设备';
      this.form = {}
      // this.modal2.house = {}
      // this.form.community_id = [];
      // this.form.house = [];
      this.form.id = null;
      this.modal.show = true;
      this.modal.isEdit = false;
    },
    editDevice(data) {
      this.modal.title = '编辑设备';

      this.form = this.$createNewVariable(data)

      DeviceService.info(data).then(res => {
        this.form.house = [{
          full_name: res.full_name,
          id: res.unit_id
        }]
      }).finally(() => {
        this.modal.show = true;
        this.modal.isEdit = false;
      })
    },
    // editDevice (data) {
    //   this.modal.id = data.id;
    //   this.form.name = data.alias;
    //   this.modal.show = true;
    // },
    delDevice(data) {
      let self = this;
      this.$confirm({
        title: '提示',
        content: '确认删除此设备？',
        onOk() {
          DeviceService.del(data).then(res => {
            self.initData();
          }).catch(err => { });
        }
      });
    },
    confirmModal2() {
      this.modal2.show = false;

      this.form.house = this.$createNewVariable(this.modal2.house);


      this.form.build_id = this.form.house && this.form.house[0].buildId
      this.form.unit_id = this.form.house && this.form.house[0].id
    },
    confirmModal() {

      // 三者必须同时存在或都不存在
      const { build, unit, house} = this.form
      if((build && unit && (house&&house.length>0)) || (!build && !unit && !(house&&house.length>0))){
        this.$beforeFormSubmit(this.$refs.modalForm, () => {
        this.modal.loading = true;
        this.form.id
          ? DeviceService.edit({ ...this.form })
            .then(res => {
              this.$afterFormSubmit(res.msg, () => {
                this.modal.show = false;
                this.initData();
              });
            }).finally(() => {
              // this.modal.show = false;
              this.modal.loading = false;
            })
          : DeviceService.add({ ...this.form, community_id: this.communityId ?? this.community.id })
            .then(res => {
              this.modal.show = false;
              this.$afterFormSubmit(res.msg, () => {
                this.initData();
              });
            }).finally(() => {
              // this.modal.show = false;
              this.modal.loading = false;
            })
      });
      }else {
        this.$message.error('单元机参数缺失，请完善信息～')
      }
      // if(this.form.build && this.form)

      
    },
    searchTable() {
      this.table.page.current = 1;
      this.initData();
    },
    resetSearchTable() {
      this.table.search = {
        number: null,
        model: null,
        type: []
      };
      this.searchTable();
    },
    handlePageChange(page) {
      this.table.page.current = page.current;
      this.table.page.pageSize = page.pageSize;
      this.initData();
    },
    initData() {
      // 编辑的时候 构造一下已选的数据
      // this.form.house = res.owner_housing.map(val => {
      //       val[this.tree.params.title] = val.full_name;
      //       val._id = val.id;
      //       return val;
      //     });
      this.table.loading = true;
      this.$emit('total', 0);
      DeviceService.listPage(
        this.communityId ?? this.community.id,
        this.table.search.device_name,
        this.table.search.name,
        this.table.page.current,
        this.table.page.pageSize
      ).then(res => {
        // this.table.data = res.data.map(val => {
        //   val.showLoading = false;
        //   val.typeText = deviceTypeText(val.devType);
        //   return val;
        // });
        this.table.data = res.data
        this.table.page.total = res.meta.pagination.total;
        this.$emit('total', res.meta.pagination.total);
      }).catch(err => { }).finally(() => {
        this.table.loading = false;
      });
    }
  },
}
</script>

<style lang="less" scoped>

</style>